import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=2658fb7b&"
import script from "./Banner.vue?vue&type=script&lang=js&"
export * from "./Banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2658fb7b')) {
      api.createRecord('2658fb7b', component.options)
    } else {
      api.reload('2658fb7b', component.options)
    }
    module.hot.accept("./Banner.vue?vue&type=template&id=2658fb7b&", function () {
      api.rerender('2658fb7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/option/Banner.vue"
export default component.exports